import addTextToFeatureTable from "./add_text_to_feature_table";
import creditCardParameters from "../datasets/credit_card_parameters";
import checkIfCreditCardEligible from "../objects/check_if_credit_card_eligible";
import { doubleToStringMonthly, standardNumberFormat } from "../../../objects/CommonUse/double_functions";

export const getCreditCardCriteria = (creditReport, featureCriteria, annualSalary, featureTextArr, 
        featureCriteriaArr, eligible) => {
    let featureBulletText = "";
    const creditMaxAmtObj = creditCardParameters[featureCriteria.level - 1];
    const creditMaxAmt = creditMaxAmtObj.maxCreditCardAmt;
    const eligibleCreditCardObj = checkIfCreditCardEligible(annualSalary, creditMaxAmt, 
        creditReport);
    featureBulletText = "Credit Score must be at least " + eligibleCreditCardObj.creditScoreMinimum + 
        " Your credit score is " + standardNumberFormat(eligibleCreditCardObj.creditScore);
    eligible = addTextToFeatureTable(featureBulletText, "creditScore", 
        eligibleCreditCardObj.creditScoreMinimum, eligibleCreditCardObj.creditScore, 
        featureTextArr, featureCriteriaArr, eligible);
    featureBulletText = "Your gross yearly salary is " + doubleToStringMonthly(annualSalary) +
        ". It must be at least " +  eligibleCreditCardObj.grossIncomeMultiplier + " times the credit " +
        "card maximum.  Your salary is  " + (+eligibleCreditCardObj.annualSalaryMultiplier).toFixed(0) +
            " time(s) the credit maximum";
    eligible = addTextToFeatureTable(featureBulletText, "grossSalary", 
        eligibleCreditCardObj.minGrossSalary, annualSalary, featureTextArr, featureCriteriaArr, eligible); 
    return eligible;
}
export default getCreditCardCriteria;